<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AFpq">
<div class="image1"><img alt="images/himg-6-1.jpg" src="images/himg-6-1.jpg"/></div>
<p class="noind" id="pz23-3"><b><span class="dcap">P</span></b>eople who love Jesus are supposed to act differently than those who don’t. They should have different activities on Sunday morning, different ways to spend their money, a different perspective on current events, and a compassion and peace that perplexes the world. But the temptation to blend in with the culture and remain silent about faith can be quite strong at times. </p>
<p id="pz23-5">Maybe people will know you by your love for others, but as Jesus pointed out in His Sermon on the Mount, there is nothing remarkable about your love if you only love people who love you in return. Yet Jesus’ command was to “love your enemies” (v. 44). And He continued: “Bless those who curse you, do good to those who hate you, and pray for those who spitefully use you” (v. 44). You should be known for the love you show to those who treat you poorly. </p>
<p id="pz23-6">Who has hurt you, cursed you, or used you? What will loving those people require of your actions and words? Choose one of those people to love this week. Start with a small step—and know that God will smile on your obedience. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter18.vue?4982c934